import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Row, Col, Alert, Container, CardBody, Card } from "reactstrap";
import URLSearchParams from "@ungap/url-search-params";
import { connect } from "react-redux";
import { withRouter, Link, Redirect } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
// actions
import { loginUser, apiError, socialLogin } from "../../store/actions";
import { FaHome } from "react-icons/fa";

// import image
import CMSLogo from "../../assets/images/long-logo.svg";
import { CircularProgress } from "@material-ui/core";
import { useAuth } from "../../Context/Auth";

const Login = (props) => {
  const [loader, setLoader] = useState(false);
  const [Email, setEmail] = useState("");
  const [EmailError, setEmailError] = useState(null);
  const [Password, setPassword] = useState("");
  const [PasswordError, setPasswordError] = useState(null);
  const [AcountBlock, setAcountBlock] = useState(null);
  const [isLoggedIn, setLoggedIn] = useState(false);
  const [isLoggedInMerchant, setLoggedInMerchant] = useState(false);
  const { setAuthTokens } = useAuth();

  const queryString = new URLSearchParams(window.location.search);

  useEffect(() => {
    // check for the token query string param
    let queryToken = queryString.get("token");

    if (queryToken) {
      console.log("checking token props coming in", queryToken);
      setLoggedInMerchant(true);
      setAuthTokens(queryToken);
      localStorage.setItem("isMerchant", "true");
      localStorage.setItem("merchantToken", queryToken);
      localStorage.setItem(
        "userPermissions",
        JSON.stringify({ campaigns: { add: 1, update: 1, delete: 1, view: 1 } })
      );
      return;
    }
    const token = localStorage.getItem("AuthenticationToken");
    if (token) {
      setLoggedIn(true);
    }
    // remove classname when component will unmount
    return function cleanup() {};
  }, []);
  function isValidEmail(email) {
    return /^[\w\.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,})$/.test(email);
  }
  const emailcheck = (e) => {
    setEmail(e.target.value);
    if (e.target.value.length > 0) {
      if (!isValidEmail(e.target.value)) {
        setEmailError("Email is invalid");
      } else {
        setEmailError(null);
      }
    } else {
      setEmailError("Please enter email");
    }
  };

  const passwordcheck = (e) => {
    setPassword(e.target.value);
    if (e.target.value.length > 0) {
      setPasswordError(null);
    } else {
      setPasswordError("Please enter password");
    }
  };

  // handleSubmit
  const handleSubmit = async () => {
      if(!Password || !Email){
        return
      }
      setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    var urlencoded = new URLSearchParams();
    urlencoded.append("email", Email);
    urlencoded.append("password", Password);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    let loginResponse = await fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/login`,
      requestOptions
    ).then((response) => {
      return response.json();
    }).catch((error)=>console.log("error",error));
    let responseMessage = await loginResponse;
    console.log("Login Response", responseMessage?.token);
    if (responseMessage?.user_id) {
      setLoader(false);
      props.history.push("/otp-login", { userId: responseMessage?.user_id });
    } else {
      setLoader(false);
      if (responseMessage?.invalid_credentials) {
        setPasswordError(responseMessage?.message);
      } else if (responseMessage?.account_locked) {
        setAcountBlock(responseMessage?.message);
      } else if (responseMessage?.password_expired) {
        setAcountBlock(responseMessage?.message);
      } else if (responseMessage?.account_disabled) {
        setAcountBlock(responseMessage?.message);
      } else if(responseMessage?.old_password_used){
        setAcountBlock(responseMessage?.message)
      }
    }
  };

  if (isLoggedInMerchant || localStorage.getItem("isMerchant") == "true") {
    return <Redirect to="/merchant-dashboard" />;
  }
  if (isLoggedIn) {
    let role = localStorage.getItem("userRole");
    if (role) {
      if (role.toLowerCase().includes("merchant")) {
        return <Redirect to="/merchant-dashboard" />;
      } else if (role.toLowerCase().includes("promo")) {
        return <Redirect to="/select-merchant" />;
      } else {
        return <Redirect to="/carousel-banners/frx-home" />;
      }
    }
  }

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <FaHome size={32} />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center">{/* div for logo etc */}</div>
            </Col>
          </Row>
          <Row className="align-items-center justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card>
                <CardBody className="p-5">
                  <Link to="/" className="mb-2 d-block auth-logo">
                    <img
                      style={{ marginLeft: "auto", marginRight: "auto" }}
                      src={CMSLogo}
                      alt=""
                      height="40"
                      className="logo logo-dark"
                    />
                  </Link>
                  <div className="text-center mt-3">
                    <h5
                      style={{
                        color: "#000000 !important",
                        fontSize: 15,
                        margin: 0,
                      }}
                    >
                      WELCOME
                    </h5>
                    <p
                      style={{ color: "#000000 !important" }}
                      className="text-muted"
                    >
                      Please login to access the FRx app CMS
                    </p>
                  </div>
                  <div className="p-2 mt-4">
                    <AvForm className="form-horizontal">
                      {props.error && typeof props.error === "string" ? (
                        <Alert color="danger">{props.error}</Alert>
                      ) : null}

                      <div className="mb-3">
                        <AvField
                          name="email"
                          label="Email"
                          className="form-control"
                          placeholder="Enter email"
                          onChange={(e) => {
                            emailcheck(e);
                            setAcountBlock("");
                          }}
                        />
                        {EmailError ? (
                          <div
                            style={{
                              fontSize: 12,
                              color: "red",
                              fontWeight: 400,
                            }}
                          >
                            {EmailError}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Password</label>
                        <input 
                        className="password-input"
                        id="password"
                        name="password"
                        type="password" 
                        placeholder="Enter Password"
                        onChange={(e) => {
                            passwordcheck(e);
                            setAcountBlock("");
                          }}
                        />
                        {PasswordError ? (
                          <div
                            style={{
                              fontSize: 12,
                              color: "red",
                              fontWeight: 400,
                            }}
                          >
                            {PasswordError}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="mt-3">
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          type="submit"
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          {loader ? (
                            <CircularProgress
                              size={15}
                              value={100}
                              color={"white"}
                            />
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                      {AcountBlock ? (
                        <div
                          style={{
                            fontSize: 12,
                            color: "red",
                            fontWeight: 400,
                            marginTop: 2,
                          }}
                        >
                          {AcountBlock}
                        </div>
                      ) : (
                        ""
                      )}

                      <div className="mt-3 text-center text-decoration-underline">
                        <Link to="/reset-password" className="text-dark">
                          Reset Password
                        </Link>
                      </div>
                    </AvForm>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error } = state.Login;
  return { error };
};

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError, socialLogin })(Login)
);

Login.propTypes = {
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
  socialLogin: PropTypes.func,
};
